/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryUploadInfoDto } from '../../models/binary-upload-info-dto';

export interface UploadBinary$Params {
  'X-API-Version'?: string;
      body?: {
'file': Blob;
}
}

export function uploadBinary(http: HttpClient, rootUrl: string, params?: UploadBinary$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryUploadInfoDto>> {
  const rb = new RequestBuilder(rootUrl, uploadBinary.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryUploadInfoDto>;
    })
  );
}

uploadBinary.PATH = '/api/binaries';
